<style lang="less" scoped>
@import './index.less';
</style>

<template>
    <div class="login-container">
        <div class="login-form-div">
            <!-- 登录表单 -->
            <div class="form-child-div">
                <div class="pro-title-div">
                    挚达资产管理平台
                </div>
                <div class="form-line-title">请选择所属公司</div>
                <div class="form-line-input">
                    <el-select class="full-width" v-model="formInfo.dataCheck" size="small" clearable disabled>
                        <el-option v-for="(item, index) in orgList" :disabled='item.isDisable' :label="item.label"
                            :value="item.value" :key="index"></el-option>
                    </el-select>
                </div>
                <div class="form-line-title">请输入手机号</div>
                <div class="form-line-input">
                    <input type="text" v-model="formInfo.userPhone" :disabled='!formInfo.dataCheck' size="small"
                        @keydown.enter="submitForm" class="form-input user-name-input" />
                </div>
                <div class="form-line-title pwd-title">请输入密码</div>
                <div class="form-line-input">
                    <input type="password" v-model="formInfo.userPassword" :disabled='!formInfo.dataCheck'
                        @keydown.enter="submitForm" class="form-input user-name-input" />
                </div>
                <div class="submit-btn-div">
                    <button class="submit-btn" @click="submitForm">登 录</button>
                </div>
            </div>
            <!-- version -->
            <div class="ab-version-div">版本:1.1.0</div>
        </div>
        <div class="fixed-auth-div">
            <div class="auth-up-div flex">
                <div class="text-center flex-1">挚达科技</div>
                <div class="text-center flex-1">服务协议</div>
                <div class="text-center flex-1">客服:400-6596-580</div>
            </div>
            <div class="auth-bottom-div">
                <span class="copyright">Copyright © 2012-2020 上海挚达科技发展有限公司版权所有</span>
                <span class="ba">沪ICP备14017068号-9A</span>
            </div>
        </div>
    </div>
</template>

<script>
import enAes from "../../common/enAes";
export default {
    data() {
        return {
            formInfo: {
                dataCheck: '公司端'
            },
            orgList: [
                {
                    label: '超管端',
                    value: 1,
                    isDisable: true
                },
                {
                    label: '公司端',
                    value: 2
                },
            ]
        };
    },
    methods: {
        init() { },
        // 登录
        submitForm(formName) {
            let _ = this;
            // 判断用户名是否输入
            if (_.$U.isEmpty(_.formInfo.userPhone)) {
                _.$U.error("请输入手机号");
                return;
            }
            // 判断用户名是否输入
            if (_.$U.isEmpty(_.formInfo.userPassword)) {
                _.$U.error("请输入密码");
                return;
            }

            //判断手机号是否输入正确
            var strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (strTemp.test(_.formInfo.userPhone)) { } else {
                _.$U.error("请输入正确的手机号");
                return false;
            }

                _.$U.showLoading(_);
                _.formInfo.corpNo = _.$C.corpNo;
                _.formInfo.loginType = "01";
                // _.formInfo.dataCheck = "N";
                _.$H.post(_, _.$A.login, _.formInfo).then((res) => {
                    let token = res.headers.authorization;
                    _.$store.commit("setToken", token);
                    _.$store.commit("setCorpNo", _.$C.corpNo);
                    // 获取当前用户信息
                    _.$H.get(_, _.$A.user.currentUserInfo, {}).then((userRes) => {
                        const roleId = userRes.data.data.roleId;
                        _.$store.commit("setUserInfo", userRes.data.data);
                        // 获取当前用户的菜单列表
                        _.$H.post(_, _.$A.role.listmenu, {roleId: roleId}).then((userMenus) => {
                            let menuRes = userMenus.data.data;
                            let menuList = [];
                            let mainMenuList = [];
                            menuRes.forEach((menu) => {
                                if(menu.menuLevel == 1){
                                    mainMenuList.push(menu.menuNameZh)
                                }
                                menuList.push(menu.menuNameEn);
                            });
                            // 自主添加路由
                            // menuList.push('refundTotalOrderList')
                            // menuList.push('serviceTotalOrderList')
                            // menuList.push('sharedSwitch') // 共享开关设备列表
                            // menuList.push('sharedBookingOrders') // 共享预约订单

                            _.$store.commit("setCurMainMenuList", mainMenuList);
                            _.$store.commit("setCurUserAuthList", menuList);
                            _.$store.commit("setCurUserMenuList", menuList);
                            
                            console.log(mainMenuList);
                            _.$U.hideLoading(_);
                            // _.$router.push({
                            //     name: "dashboard",
                            // });
                            _.$router.push({
                                // name: "noticeList",
                                name: "mainMenu",
                            });
                        });
                    });
                });
        },
    },
    mounted() {
        this.init();
    },
};
</script>
